//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import getUserInfo from '@/common/utils/getUserInfo'
import { getLikeCount } from '@/views/building/comments/utils'
import WxUsername from './_wx_username'
import { sendCtmEvtLog } from '@/utils/log'
import { openChat } from '@/data/im'
import { App_User } from '@/data/user_info'
export default {
    components: {
        WxUsername
    },
    data () {
        return {
            liking: false,
            show_all_reply: false
        }
    },
    computed: {
        like_count () {
            const { is_liked, like_count } = this.comment
            return getLikeCount(is_liked, like_count)
        },
        show_reply () {
            if (this.show_all_reply) {
                return this.comment.reply_comments.items.slice(0)
            }
            return this.comment.reply_comments.items.slice(0, 3)
        }
    },
    methods: {
        onConsult (id) {
            const { building_id } = this.$route.query
            if (id) {
                sendCtmEvtLog('咨询点击-置业顾问评论', {
                    consultant_id: id
                })
                openChat(id, {
                    from: '评论区',
                    building_id
                })
            }
        },
        clickHeadming (e) {
            if (!this.comment.consultant_id) {
                this.goDetail()
            }
        },
        goDetail () {
            const { name, building_id } = this.$route.query
            this.$router.push({
                path:`/building/comments/detail?building_id=${building_id}&id=${this.comment.id}&name=${name||''}`
            })
        },
        tapComment (e) {
            if (!this.comment.is_official) {
                const { reply_comments } = this.comment
                if (reply_comments && reply_comments.total_count) {
                    this.goDetail()
                } else {
                    this.goReply(e)
                }                
            }

        },
        toggleReplyShow () {
            this.show_all_reply = !this.show_all_reply
        },
        replyUser (e) {
            const { index: reply_index } = e.currentTarget.dataset
            if (this.is_building_page) {
                return this.goDetail()
            }
            this.$emit('addComment', this.index, reply_index)
        },
        onLike (e) {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    if (this.liking) {
                        return
                    }
                    this.liking = true
                    const { id } = e.currentTarget.dataset
                    const { comment } = this
                    let method = 'likeComment'
                    if (comment.is_liked) {
                        method = 'delLikedComment'
                    }
                    Service[method](id).then(() => {
                        this.changeLike(!comment.is_liked)
                    })
                }
            })
        },
        changeLike (like) {
            const { comment } = this
            comment.is_liked = like
            comment.like_count = like ? comment.like_count + 1 : comment.like_count - 1
            this.liking = false
            this.$emit('changeComment', comment, this.index)
        },
        goReply (e) {
            if (this.is_building_page) {
                return this.goDetail()
            }
            this.$emit('addComment', this.index)
        },
        stopClick () {},
        previewImg(e) {
            const { photos_urls } = this.comment
            const current = photos_urls[0]
            this.$wx.previewImage({
                current,
                urls: photos_urls
            })
        }
    },
    props: {
        index: {
            type: Number
        },
        comment: {
            type: Object
        },
        is_building_page: {
            type: Boolean,
            default: false
        }
    }
}
